module.exports = __webpack_public_path__ + "static/bl-2-b9ccb91cd260047d3155c6dd1790bd32.png";